import styled from 'styled-components';

export const StyledNoThread = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-items: center;
    align-self: stretch;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 0.2rem;
`;

export const StyledNoThreadSelectedText = styled.div`
    max-width: 29rem;
    padding-right: 1.2rem;
    padding-left: 1.2rem;
    color: ${({ theme }) => theme.color.black};
    text-align: center;
`;
